import React, { Fragment } from 'react';
import LazyLoad from 'react-lazyload';
import Dotdotdot from 'react-dotdotdot';

import { Helpers } from '../../core/src/helpers';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import ProductPrice from '../../product/components/product-price';
import PurchaseButton from '../../product/components/purchase-button-container';
import RemoveButton from '../../utility/components/remove-btn';

import '../css/reorder-product.less';


export default ({ product, isFreeShipping, isReorderProduct = false, className, prdCartRecord }) => {
    const { attributes = {}, quantity, images } = product;
    let { pageyielda4bw, pageyielda4clr, crtgclrcodes = [] } = attributes;
    const imageUrl = Helpers.getCDNUrl((images[0] || {}).cdn, (images[0] || {}).lrg, 300);
    const isXL = /XL/.test(product.name);
    if (typeof crtgclrcodes === 'string') {
        crtgclrcodes = [crtgclrcodes];
    }

    return (
        <div className={`reorder-prd-card${className ? ' ' + className : ''}`}>
            <div className='reorder-top'>
                <LazyLoad height={200} once={true} offset={400}>
                    <ImageWithPlaceholder className='prd-img' src={imageUrl} />
                </LazyLoad>
                <div className='prd-details'>
                    <h2 className='prd-header'>{product.name}</h2>
                    <Dotdotdot clamp={1} className='prd-clamp'>
                        <span className='prd-color-dot'></span>
                        {crtgclrcodes.map((hex, i) => {
                            let marginRight = i === crtgclrcodes.length - 1 ? "5px" : "1px";
                            return (<span key={i} className='cartridge-color' style={{ backgroundColor: hex, marginRight }} />)
                        })}
                        {isXL && <span className='prd-type'>XL</span>}
                        <span className='prd-page-yield'>{attributes.pageyielda4bw || attributes.pageyielda4clr}</span>
                    </Dotdotdot>
                </div>
            </div>
            <div className='reorder-mid'>
                {
                    isFreeShipping &&
                    <Fragment>
                        <div>Fast, free shipping every day</div>
                    </Fragment>
                }
            </div>
            <div className='reorder-bottom'>
                <ProductPrice product={product} />
                {
                    !prdCartRecord ?
                        <PurchaseButton
                            showSelector={true}
                            product={product}
                            customCtaText={isReorderProduct && 'Reorder'}
                            quantity={quantity}
                        /> :
                        <RemoveButton
                            showSelector={true}
                            product={product}
                            prdCartRecord={prdCartRecord}
                        />
                }
            </div>
        </div>
    );
};
